import { render, staticRenderFns } from "./SaveCancel.vue?vue&type=template&id=4abe1896&"
import script from "./SaveCancel.vue?vue&type=script&lang=js&"
export * from "./SaveCancel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports